import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/codebuild/output/src1006553232/src/helloero-new/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1006553232/src/helloero-new/node_modules/next/dist/client/link.js");
